import type { EnhancedProductFamilyId, EnhancedProductGroup } from '#api/enhancements/enhancedTmsApiTypes'
import { getFamilySelectionMetaData } from '#features/NationalCodes/selectionHelpers'
import type { TruckConfiguration } from '#store/slices/configurationSlice'

const flatGroup = (group: EnhancedProductGroup) => [group, ...(group.subGroups ?? [])]

export function calculateTotalConfigurationPrice(
  productGroups: TruckConfiguration['productGroups'],
  marketData: TruckConfiguration['marketData'] | undefined,
  configuredFamilies: TruckConfiguration['configuredFamilies'] | undefined,
) {
  let totalPrice = 0

  const productsPrice = productGroups
    .flatMap(flatGroup)
    .flatMap((x) => x.families)
    .filter((x) => !!x)
    .map((x) => x.variants.find((x) => x.isSelected))
    .filter((x) => !!x)
    .map((x) => x.dummy_price)
    .filter((x) => x !== undefined)
    .reduce((a, b) => a + b, 0)

  totalPrice += productsPrice

  if (marketData) {
    const nationalCodesPrice = marketData.groups
      .flatMap((g) => g.families ?? [])
      .flatMap((f) => getFamilySelectionMetaData(f, configuredFamilies?.[f.familyId as EnhancedProductFamilyId])?.attributes?.grossListPrice ?? 0)
      .reduce((a, b) => a + b, 0)

    totalPrice += nationalCodesPrice
  }

  return totalPrice
}
